import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { TimepickerComponent,timer } from '../timepicker/timepicker.component';

@Component({
  selector: 'app-calendar-manage',
  templateUrl: './calendar-manage.component.html',
  styleUrls: ['./calendar-manage.component.scss'],
})
export class CalendarManageComponent {

  constructor(private service: ApiService, 
              public dialog: MatDialog,
              public handler: HandlerService) { }

  loader: boolean;
   font;
  items = [];

  ionViewWillEnter() {
    this.font = "normal";
    let a = localStorage.getItem('fontSizeId');
    if (a == '1') {
      this.font = 'normal'
    }
    if (a == '2') {
      this.font = 'medium'
    }
    if (a == '3') {
      this.font = 'large'
    }
    this.items = [
      { name: 'MONDAY', day: "MON", active: false, show: false, slots: [] },
      { name: "TUESDAY", day: "TUE", active: false, show: false, slots: [] },
      { name: "WEDNESDAY", day: "WED", active: false, show: false, slots: [] },
      { name: "THURSDAY", day: "THU", active: false, show: false, slots: [] },
      { name: "FRIDAY", day: "FRI", active: false, show: false, slots: [] },
      { name: "SATURDAY", day: "SAT", active: false, show: false, slots: [] },
      { name: "SUNDAY", day: "SUN", active: false, show: false, slots: [] }
    ]
    let post = {
      "targetCenterId": localStorage.getItem('currentUserId'),
      "targetSource": localStorage.getItem('currentUserId')
    }
    this.loader = true;
    this.service.manageCalGet(post).subscribe((res: any) => {
      if (res != null && res != "NO_CONTENT" && res.length > 0) {
        this.items.map(item => {
          res.map(val => {
            if (val.capDefDays.includes(item.day)) {
              item.active = true;
              item.slots.push({ startTime: val.startTime, endTime: val.endTime, edit: false, id: val.id })
            }
          })
        })
      }
      this.loader = false;
    }, err => {
      this.loader = false;
      this.handler.err(err);
    })
  }

  defaulter(data, start, end, what) {
    return data.substring(0, start) + what + data.substring(end);
  };

  open(i) {
    if (i != null) {
      this.items.map((res, j) => {
        if (i == j)
          this.items[i].show = this.items[i].show == false ? true : false;
        else
          res.show = false
      })
    }
  }

  submit() {
    this.items.map(res=>{
      res.slots.map(val=>{
        if(!val.id){
          this.loader = true;
          let post = {
            "activeInd": "Y",
            "targetCenterId": localStorage.getItem('currentUserId'),
            "targetSource": localStorage.getItem('currentUserId'),
            "startTime": val.startTime,
            "endTime": val.endTime,
            "maxAllowedAppts": "1",
            "perApptDuration": "00:15",
            "capDefDays": [res.day],
            "capDefSchElements": [1]
          }
          this.service.manageCalPost(post).subscribe(res => {
            this.handler.res('Calendar updated successfully');
            this.ionViewWillEnter();
            this.open(null)
          }, err => {
            this.loader = false;
            this.handler.err(err);
          })
        }
      })
    })
    
  }
  addSlots(i) {
    let date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    let x = new Date(date).toDateString()
    this.items[i].slots.push({ startTime: '00:00', endTime: '00:00', edit: true })
  }
  removeSlots(i,j,slot) {
    if(slot.id){
      this.loader = true;
      this.service.deleteSlots(slot.id).subscribe(res => {
        this.loader = false;
        this.handler.res('Deleted Successfully');
        this.ionViewWillEnter();
        this.open(null)
      },err=>{
        this.loader = false;
        this.handler.err(err)
      })
    }
    else{
      this.items[i].slots.splice(j, 1);
    }
  }

  openModel(id,i,j): void {
    const dialogRef = this.dialog.open(TimepickerComponent, {
      width: '100%'
    });

    dialogRef.afterClosed().subscribe(()=> {
      if(id==1){
        this.items[i].slots[j].startTime=timer;
      }
      if(id==2){
        this.items[i].slots[j].endTime=timer;
      }
    });
  }

}

